import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { OwnerCatalogScreen } from '../features/catalog-owner/OwnerCatalogScreen'

export const Route = createFileRoute('/owner-catalog')({
  component: () => <RequireAuth><OwnerCatalogScreen /></RequireAuth>,
})
